'use client';

import { useEffect, useState } from 'react';
import { Link } from '@/i18n/routing';
import { SectionLabel } from '@/components/shared/SectionLabel';
import { useTranslations } from '@/i18n/intl';
import { getPeople } from '@/lib/actions/people';
import { PeopleCarousel } from './PeopleCarousel';

export function PeopleSection() {
  const t = useTranslations('People');
  const tCommon = useTranslations('Common');
  const [people, setPeople] = useState<any[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getPeople().then((data) => {
      if (cancelled) return;
      setPeople(data);
      setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready || people.length === 0) return null;

  return (
    <section className="py-10 md:py-[72px] px-5 md:px-[40px] bg-navy">
      <div className="max-w-[1170px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <SectionLabel text={tCommon('ourPeople')} className="text-white" />
            <h2
              className="text-[32px] md:text-[40px] font-normal text-white font-heading leading-[1.08] max-w-[700px] md:mr-[220px]"
            >
              {t('headline')}
            </h2>
          </div>
          <div className="shrink-0">
            <Link
              href="/about-us#our-team"
              className="inline-flex items-center bg-primary text-navy text-[14px] font-semibold uppercase px-[25px] py-[11px] rounded-[25px] hover:bg-white hover:text-navy transition-all duration-300"
            >
              {tCommon('ourPeople')}
            </Link>
          </div>
        </div>

        <PeopleCarousel people={people} />
      </div>
    </section>
  );
}
